// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3EzsL","checkboxCol":"Table_checkboxCol__ld3A0","emailCol":"Table_emailCol__2KNCK","actionCol":"Table_actionCol__2kArE"};